//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_sceneModeMorphing = 0.0;\n\
";
